var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _path, _rect44, _rect45, _rect46, _rect47, _rect48, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 200,
    viewBox: "0 0 294 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 200,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44.4048,
    width: 123.971,
    height: 111.19,
    rx: 7.70514,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8984,
    y: 57.1855,
    width: 67.7366,
    height: 10.2244,
    rx: 5.1122,
    fill: "#A3BBD1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0586,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0586,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1172,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1172,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4531,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4531,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5117,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5117,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8496,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8496,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 104.186,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 104.186,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 118.244,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 118.244,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1",
    fillOpacity: 0.22
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5117,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8496,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 104.186,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 118.244,
    y: 81.4683,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0586,
    y: 95.5269,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1172,
    y: 95.5269,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4531,
    y: 95.5269,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5117,
    y: 95.5269,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8496,
    y: 95.5269,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 104.186,
    y: 95.5269,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 118.244,
    y: 95.5269,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0586,
    y: 109.585,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1172,
    y: 109.585,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4531,
    y: 109.585,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#003A70"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5117,
    y: 109.585,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8496,
    y: 109.585,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 104.186,
    y: 109.585,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 118.244,
    y: 109.585,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0586,
    y: 123.644,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1172,
    y: 123.644,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4531,
    y: 123.644,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5117,
    y: 123.644,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8496,
    y: 123.644,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 104.186,
    y: 123.644,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 118.244,
    y: 123.644,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0586,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1172,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4531,
    y: 136.424,
    width: 6.39024,
    height: 6.39024,
    rx: 2.5561,
    fill: "#A3BBD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0773 56.2741H41.2964V55.4932C41.2964 55.0638 40.9451 54.7124 40.5156 54.7124C40.0862 54.7124 39.7348 55.0638 39.7348 55.4932V56.2741H33.4881V55.4932C33.4881 55.0638 33.1368 54.7124 32.7073 54.7124C32.2778 54.7124 31.9265 55.0638 31.9265 55.4932V56.2741H31.1456C30.2789 56.2741 29.5918 56.9768 29.5918 57.8357L29.584 68.7673C29.584 69.6263 30.2789 70.329 31.1456 70.329H42.0773C42.9362 70.329 43.6389 69.6263 43.6389 68.7673V57.8357C43.6389 56.9768 42.9362 56.2741 42.0773 56.2741ZM42.0773 67.9865C42.0773 68.416 41.7259 68.7673 41.2964 68.7673H31.9265C31.497 68.7673 31.1456 68.416 31.1456 67.9865V60.1782H42.0773V67.9865ZM32.7073 61.7399H34.269V63.3015H32.7073V61.7399ZM35.8306 61.7399H37.3923V63.3015H35.8306V61.7399ZM38.9539 61.7399H40.5156V63.3015H38.9539V61.7399Z",
    fill: "#003A70"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 154.029,
    y: 44.4053,
    width: 123.971,
    height: 111.19,
    rx: 7.70514,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 194.928,
    y: 57.1855,
    width: 67.7366,
    height: 10.2244,
    rx: 5.1122,
    fill: "#A3BBD1"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 166.811,
    y: 101.917,
    width: 37.0634,
    height: 10.2244,
    rx: 5.1122,
    fill: "#A3BBD1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 166.811,
    y: 101.917,
    width: 40.8976,
    height: 10.2244,
    rx: 5.1122,
    fill: "#A3BBD1"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 221.766,
    y: 101.917,
    width: 40.8976,
    height: 10.2244,
    rx: 5.1122,
    fill: "#A3BBD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.642 54.7129C170.332 54.7129 166.842 58.211 166.842 62.5212C166.842 66.8314 170.332 70.3295 174.642 70.3295C178.96 70.3295 182.458 66.8314 182.458 62.5212C182.458 58.211 178.96 54.7129 174.642 54.7129ZM174.65 68.7678C171.199 68.7678 168.403 65.9725 168.403 62.5212C168.403 59.0699 171.199 56.2746 174.65 56.2746C178.101 56.2746 180.897 59.0699 180.897 62.5212C180.897 65.9725 178.101 68.7678 174.65 68.7678ZM174.478 58.617H174.431C174.119 58.617 173.869 58.8669 173.869 59.1792V62.8648C173.869 63.138 174.01 63.3957 174.252 63.5363L177.492 65.4805C177.758 65.6367 178.101 65.5586 178.258 65.2931C178.422 65.0277 178.336 64.6763 178.062 64.5201L175.041 62.7242V59.1792C175.041 58.8669 174.791 58.617 174.478 58.617Z",
    fill: "#003A70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 96.8071C190.341 96.5699 190.341 96.1867 190.103 95.9495L187.312 93.1579C187.075 92.9207 186.691 92.9207 186.454 93.1579L183.663 95.9495C183.425 96.1867 183.425 96.5699 183.663 96.8071C183.9 97.0442 184.283 97.0442 184.52 96.8071L186.886 94.4473L189.246 96.8071C189.483 97.0442 189.872 97.0382 190.103 96.8071Z",
    fill: "#003A70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.674 118.531C183.437 118.768 183.437 119.151 183.674 119.388L186.466 122.18C186.703 122.417 187.086 122.417 187.323 122.18L190.115 119.388C190.352 119.151 190.352 118.768 190.115 118.531C189.878 118.294 189.494 118.294 189.257 118.531L186.891 120.891L184.532 118.531C184.294 118.294 183.905 118.3 183.674 118.531Z",
    fill: "#003A70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.056 96.8071C245.294 96.5699 245.294 96.1867 245.056 95.9495L242.265 93.1579C242.028 92.9207 241.645 92.9207 241.407 93.1579L238.616 95.9495C238.378 96.1867 238.378 96.5699 238.616 96.8071C238.853 97.0442 239.236 97.0442 239.473 96.8071L241.839 94.4473L244.199 96.8071C244.436 97.0442 244.825 97.0382 245.056 96.8071Z",
    fill: "#003A70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.627 118.531C238.39 118.768 238.39 119.151 238.627 119.388L241.419 122.18C241.656 122.417 242.039 122.417 242.276 122.18L245.068 119.388C245.305 119.151 245.305 118.768 245.068 118.531C244.831 118.294 244.448 118.294 244.21 118.531L241.844 120.891L239.485 118.531C239.247 118.294 238.858 118.3 238.627 118.531Z",
    fill: "#003A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.714e2758342b868eec1eecc00f7e7486.svg";
export { ForwardRef as ReactComponent };